import { CSSProperties } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { captureException } from '@sentry/react';
import { AxiosResponse } from 'axios';
import { toast } from '@/shared/components/toasts/PlatformToast';

import { authorizedAxiosInstance } from '@/clients';

import { createDataSourceSections, DataSourceConnectionParams } from './dataSources/dataSourceSections';
import { dataSourceLabelFor } from './dataSources/dataSourceLabels';

export const useDataSources = () => {
    const handleConnectDataSource = async (option: string, params?: DataSourceConnectionParams) => {
        try {
            toast('Connecting...', {
                icon: <LoadingOutlined spin />,
                description: option && dataSourceLabelFor(option, params),
            });

            await authorizedAxiosInstance
                .get('/api/auth/account/' + option + '/url', { params })
                .then((res: AxiosResponse) => {
                    if (res?.status === 200) {
                        window.location.href = res?.data?.url;
                    }
                });
        } catch (error) {
            captureException(error);
        }
    };

    const categoryIconStyle = {
        verticalAlign: '-0.1rem',
        marginRight: '0.2rem',
    } as CSSProperties;

    const sectionIconStyle = {
        verticalAlign: '-0.15rem',
        marginRight: '0.375rem',
    } as CSSProperties;

    const dataSources = createDataSourceSections({
        categoryIconStyle,
        handleConnectDataSource,
        sectionIconStyle,
    });

    return { dataSources };
};
